
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _setPrototypeOf from './setPrototypeOf.js';

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

export { _inheritsLoose as default };
//# sourceMappingURL=inheritsLoose.js.map
